import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import * as _ from 'lodash';

import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { APPLICATION_HUB_CONTACT_INFO_FORM_NAME } from 'Common/FormEnum';
import { InputField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import {
  normalizePhone,
  isValidEmail,
  normalizeNumeric,
  isValidPhone,
} from 'Common/FormHelper';
import StateDropdown from 'Common/Components/StateDropdown/StateDropdown';
import { TitledCard } from 'Components';

class ContactInfoForm extends Component {
  render() {
    const { isReadOnly } = this.props;
    return (
      <TitledCard title={'Contact Information'}>
        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <Field
                  component={InputField}
                  label={'Email'}
                  maxLength={50}
                  name={Fields.EmailId}
                  disabled={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  component={InputField}
                  label={'Work Phone'}
                  type="text"
                  maxLength={14}
                  name={Fields.WorkPhone}
                  mode={InputMode.Integer}
                  format={normalizePhone}
                  normalize={normalizeNumeric}
                  disabled={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  component={InputField}
                  label={'Home Phone'}
                  maxLength={14}
                  type="text"
                  name={Fields.HomePhone}
                  mode={InputMode.Integer}
                  format={normalizePhone}
                  normalize={normalizeNumeric}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={8}>
                <Field
                  component={InputField}
                  label={'Mailing Address'}
                  maxLength={60}
                  name={Fields.Address1}
                  disabled={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <Field
                  component={InputField}
                  label={'Address 2'}
                  maxLength={30}
                  name={Fields.Address2}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  component={InputField}
                  label={'City'}
                  maxLength={30}
                  name={Fields.City}
                  disabled={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column width={7}>
                <StateDropdown name={Fields.State} disabled={isReadOnly} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  component={InputField}
                  label={'Zip Code'}
                  maxLength={5}
                  name={Fields.ZipCode}
                  mode={InputMode.Integer}
                  disabled={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </TitledCard>
    );
  }
}

const validate = (values, ownProps) => {
  const errors = {};

  if (
    values[Fields.EmailId] &&
    _.trim(values[Fields.EmailId]).length > 0 &&
    !isValidEmail(values[Fields.EmailId])
  ) {
    errors[Fields.EmailId] = 'Please enter a valid email address.';
  }

  if (values[Fields.ZipCode] && !/\d{5}/.test(values[Fields.ZipCode])) {
    errors[Fields.ZipCode] = 'Invalid ZIP Code';
  }

  if (!isValidPhone(values[Fields.WorkPhone])) {
    errors[Fields.WorkPhone] = 'Invalid Phone Number';
  }

  if (!isValidPhone(values[Fields.HomePhone])) {
    errors[Fields.HomePhone] = 'Invalid Phone Number';
  }

  return errors;
};

ContactInfoForm = reduxForm({
  validate,
  form: APPLICATION_HUB_CONTACT_INFO_FORM_NAME,
  destroyOnUnmount: true,
})(ContactInfoForm);

export { ContactInfoForm };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/ContactInfoForm.js